import React from "react";
import "./Intro.css";
import DevToLogo from "../../assets/Images/Png/dev-to.png";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link as ScrollLink } from "react-scroll";
import content from "../../content/content.js";
import Social from "../Social/Social.jsx";

const Intro = () => {
  const { introContent } = content;

  return (
    <div className="intro-cp-div ">
      <div className="intro-content-div container">
            <div className="intro-ct-title-div">
              <h1 className="intro-title">Renuka Kadari</h1>
              <h2 className="intro-sub-title">Frontend Engineer • React.js • JavaScript</h2>
              <div className="hero-stats">
                <span>✓ 3+ Years Experience</span>
                <span>✓ Software Engineer @ WebMD</span>
                <span>✓ Published Android App</span>
                <span>✓ React.js Specialist</span>
              </div>
              <p className="hero-company">📍 Hyderabad, India | Software Engineer @ WebMD</p>
        </div>
        <p className="hero-tech">
  React.js • JavaScript • HTML5 • CSS3 • REST APIs • Git
</p>        <div className="intr-ct-descri-div">
          <p className="intr-ct-descri">{introContent.introText1}</p>
          {/* <p className="intr-ct-descri">{introContent.introText2}</p> */}
          <p className="intr-ct-descri">
            {introContent.introText3}
            <ScrollLink to="about" spy={true} smooth={true} duration={500}>
              <FaArrowRightLong
                size={20}
                className="intr-about-me-icon"
                color="#545454"
              />
            </ScrollLink>{" "}
          </p>
        </div>
        <Social DevToLogo={DevToLogo}  />
      </div>
    </div>
  );
};

export default Intro;
